<cs-card [loading]="loading" hoverable>
  <div class="food-card-content">
    <div class="food-card-main-row">
      @if (showDragHandle) {
      <cs-icon name="drag-indicator" class="drag-handle" (pointerdown)="dragHandleDown.emit($event)"
        (click)="$event.stopPropagation()"></cs-icon>
      <div class="drag-hit-area" (pointerdown)="dragHandleDown.emit($event)"
        (click)="$event.stopPropagation()"></div>
      }
      @if (selectable) {
      <button class="radio-selector" (click)="handleRadioClick($event)">
        <div class="radio-icon"></div>
      </button>
      }
      @if (checkable) {
      <!-- [ariaLabel] names the food: the row can also hold a select button and badge
           tooltips, so the row text is not a name the checkbox can rely on -->
      <cs-checkbox [ariaLabel]="food?.name" [checked]="checked" [disabled]="!food?._id" (checkedChange)="checkedChange.emit($event)" (click)="$event.stopPropagation()"></cs-checkbox>
      }
      <div class="food-info">
        @if (matchPercent !== undefined) {
        <div class="food-match">{{ matchPercent }}% {{ LL.mealSuggestions.match() }}</div>
        }
        <div class="food-name-row">
          <!-- every icon and label sits beside .food-name, never inside it: E2E helpers compare
               .food-name's text exactly, so it must hold only the name -->
          <span class="food-title">
            <!-- type chip: the food's kind as a tinted icon before the name (#5615) -->
            @if (food?.recipe) {
            <span class="food-type-chip recipe" data-e2e="food-type-recipe"><cs-icon name="recipe" [attr.aria-label]="LL.foods.badges.recipe()"></cs-icon></span>
            } @else if (isLogMeal) {
            <span class="food-type-chip meal" data-e2e="food-type-meal"><cs-icon name="logged-meal" [attr.aria-label]="LL.foods.badges.meal()"></cs-icon></span>
            }
            <span class="food-name">{{ food?.name }}</span>
            @switch (origin) {
              @case (FoodOrigin.Staple) {
              <cs-icon name="shield-checkmark" fill data-e2e="food-origin-staple" [attr.aria-label]="LL.foods.badges.staple()"></cs-icon>
              }
              @case (FoodOrigin.TrustedDatabase) {
              <cs-icon name="shield-checkmark"></cs-icon>
              }
              @case (FoodOrigin.OwnFood) {
              <cs-icon name="person"></cs-icon>
              }
              @case (FoodOrigin.MemberFood) {
              <cs-badge color="gray" class="food-origin" data-e2e="food-origin" [label]="LL.foods.badges.community()"></cs-badge>
              }
              @case (FoodOrigin.OpenFoodFacts) {
              <cs-badge color="gray" class="food-origin" data-e2e="food-origin" [label]="LL.foods.badges.openFoodFacts()"></cs-badge>
              }
            }
            @if (isUsedBefore) {
            <cs-icon name="time" [attr.aria-label]="LL.foods.badges.usedBefore()"></cs-icon>
            }
            @if (likedVote > 0) {
            <cs-icon name="liked" fill data-e2e="food-liked" [attr.aria-label]="LL.foods.badges.liked()"></cs-icon>
            } @else if (likedVote < 0) {
            <cs-icon name="disliked" fill data-e2e="food-disliked" [attr.aria-label]="LL.foods.badges.disliked()"></cs-icon>
            }
          </span>
          @if (showMenuButton && menuInTitle) {
          <cs-icon-button [icon]="menuIcon" (click)="handleMenuButtonClick($event)"></cs-icon-button>
          }
        </div>
        @if (description) {
        <div class="food-description">{{ description }}</div>
        }
        <div class="food-nutrient-row">
          @if (formattedServingInfo || measuresLoading) {
          <span class="food-serving-info">
            @if (!measuresLoading) {
            <span>{{ formattedServingInfo }}</span>
            }
            @if (measuresLoading) {
            <cs-skeleton width="60px"></cs-skeleton>
            }
          </span>
          }
          @if (displayNutrients.length || measuresLoading) {
          <nutrient-list [nutrients]="displayNutrients" state="inline-compact" [expandable]="false" [hideLabel]="true"
            [loading]="measuresLoading"></nutrient-list>
          }
        </div>
        <div class="food-badges">
          @if (inconsistentNutrientsInfo) {
          <cs-badge color="red" icon="warning" [label]="LL.foods.badges.checkValues()"
            [info]="inconsistentNutrientsInfo"></cs-badge>
          } @else if (noNutritionData) {
          <cs-badge color="red" icon="warning" [label]="LL.foods.badges.noNutritionData()"></cs-badge>
          }
          @if (isLocked) {
          <cs-badge color="gray" icon="lock-closed" [label]="LL.foods.badges.locked()"></cs-badge>
          }
        </div>
      </div>
      @if (hasImage) {
      <div class="food-image">
        <img [src]="imageUrl" (error)="handleImageLoadError($event)" />
      </div>
      } @else if (showsStaplePicture) {
      <!-- a staple's own picture (staple pictures plan, #5694): the same 56 px slot, but a rounded
           square, so it never reads as a photo the user took -->
      <div class="food-image food-image--staple-picture">
        <img [src]="staplePictureUrl" alt="" data-e2e="food-staple-picture" (error)="handleStaplePictureError()" />
      </div>
      }
      @if (showMenuButton && !menuInTitle) {
        @if (menuIcon !== 'ellipsis-vertical') {
        <!-- icon-only on small screens; full labelled button where there is room
             when menuLabel is set (cs-button renders icon-only vs label-only from
             whichever input is provided) -->
        <cs-button secondary small
          [icon]="(menuLabel && !hasClientSmallScreen()) ? undefined : menuIcon"
          [label]="(menuLabel && !hasClientSmallScreen()) ? menuLabel : undefined"
          (click)="handleMenuButtonClick($event)"></cs-button>
        } @else {
        <cs-icon-button icon="ellipsis-vertical" (click)="handleMenuButtonClick($event)"></cs-icon-button>
        }
      }
    </div>
    <!-- Content projection slot for action buttons (top-right desktop, bottom-right mobile) -->
    <div class="card-actions-slot">
      <ng-content select="[card-actions]"></ng-content>
    </div>
  </div>
</cs-card>
